import { StyledProps } from '@front10';
import React from 'react';
import Box from '../../../elements/Box';
import Text from '../../../elements/Text';
import { TextProps } from '../../../elements/Text/Text';
import Title from './Title';

interface Props {
  showTitle?: boolean;
  showSpecialInstructions?: boolean;
  specialInstructions?: string;
  titleStyles?: React.ComponentPropsWithoutRef<typeof Title>;
  specialInstructionsStyles?: TextProps;
}

function SpecialInstructions({
  showTitle = true,
  showSpecialInstructions = true,
  specialInstructions = '',
  titleStyles,
  specialInstructionsStyles,
  ...props
}: StyledProps<Props>) {
  return (
    <Box
      dataTestId="specialInstructionsLayoutRow"
      display="flex"
      flexDirection="column"
      borderTop={true}
      paddingHeight="2"
      className="station-item-special-instructions"
      {...props}
    >
      {showTitle && (
        <Title
          marginBottom="1"
          leftIcon="info-circle"
          labelKey="cmp-bus-directory-map-special-instructions"
          {...titleStyles}
        />
      )}
      {showSpecialInstructions && (
        <Box display="flex">
          <Text {...specialInstructionsStyles}>{specialInstructions}</Text>
        </Box>
      )}
    </Box>
  );
}

SpecialInstructions.componentName = 'SpecialInstructions';

export default SpecialInstructions;
